export const normalizeText = (text) =>
  String(text ?? "")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .trim()
    .replaceAll(/[^\p{L}\p{N}]/gu, " ")
